(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-detailed"]) return;
  try {
    

  
  window.addEventListener('DOMContentLoaded', initComponent(jQuery) );

function initComponent($) {
  
const SOURCE = $('#description-source');
const CAROUSEL_SOURCE = $('#carousel-source');
const DESTINATION_DESCRIPTION = $('#product-description');
const DESTINATION_CLAIM = $('#product-claim');
const _data = SOURCE.html().toString().split('<hr>');
  let Video = null;

const FRAGMENT_DESCRIPTION = _data[0];

DESTINATION_DESCRIPTION.html(FRAGMENT_DESCRIPTION);

if( _data.length > 1 ) {

	_data.shift();

	DESTINATION_CLAIM.html(_data);
}
const CONTENT = CAROUSEL_SOURCE.find(" > *")
CONTENT.each(function(index, thumb){
	
  	if(index === 0){
	  	if( Video ){
  			$('#carousel-destination').append(Video);
  		}
  	}
  
  	if(index > 1){

		if($(thumb).find("[alt='hide']").length === 0 ){         
			$('#carousel-destination').append( $(this).html() )
		}
	}
	if (index === CONTENT.length -1) {
		$('#carousel-destination').slick({arrows: true, dots: true,
  			nextArrow: "<button class='slick-next slick-arrow' type='button'><svg width='17' height='33' xmlns='http://www.w3.org/2000/svg'><path d='M14.750768 16.698286L-.060661 1.886857 1 .826197l15.87209 15.872089L.999998 32.570374l-1.06066-1.06066z' fill='currentColor' fill-rule='evenodd'/></svg></button>",
			prevArrow: "<button class='slick-prev slick-arrow' type='button'><svg width='17' height='33' xmlns='http://www.w3.org/2000/svg'><path d='M2.06066 16.698286L16.87209 1.886857l-1.06066-1.06066-15.87209 15.872089 15.87209 15.872088 1.06066-1.06066z' fill='currentColor' fill-rule='evenodd'/></svg></button>",
  		});
	}

});
CAROUSEL_SOURCE.remove();

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-raccomandation"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

window.addEventListener('DOMContentLoaded', initComponent() );

function initComponent() {

  const SOURCE = $('#description-source');
  const CAROUSEL_SOURCE = $('#carousel-source');
  const DESTINATION_DESCRIPTION = $('#product-description');
  const DESTINATION_CLAIM = $('#product-claim');
  const _data = SOURCE.html().toString().split('<hr>');
  const FRAGMENT_DESCRIPTION = _data[0];
	const CONTENT = CAROUSEL_SOURCE.find(" > *")
	DESTINATION_DESCRIPTION.html(FRAGMENT_DESCRIPTION);
    
    if( _data.length > 1 ) {

        _data.shift();
        DESTINATION_CLAIM.html(_data);
    }

    CONTENT.each(function(index, thumb){

		if(index > 1){
            if($(thumb).find("[alt='hide']").length === 0 ){
				const _html = $(this).html();
				
				
                $('#carousel-destination').append( _html )
            }
        }

		if (index === CONTENT.length -1) {
            $('#carousel-destination').slick({
                arrows: true, 
                dots: true,
                nextArrow: "<button class='slick-next slick-arrow' type='button'><svg width='17' height='33' xmlns='http://www.w3.org/2000/svg'><path d='M14.750768 16.698286L-.060661 1.886857 1 .826197l15.87209 15.872089L.999998 32.570374l-1.06066-1.06066z' fill='currentColor' fill-rule='evenodd'/></svg></button>",
                prevArrow: "<button class='slick-prev slick-arrow' type='button'><svg width='17' height='33' xmlns='http://www.w3.org/2000/svg'><path d='M2.06066 16.698286L16.87209 1.886857l-1.06066-1.06066-15.87209 15.872089 15.87209 15.872088 1.06066-1.06066z' fill='currentColor' fill-rule='evenodd'/></svg></button>",
            });
        }

    });

	$(document).trigger('initComponents');

	CAROUSEL_SOURCE.remove();
}

  } catch(e) { console.error(e); }
})();

})();
